export * from "./about-page";
export * from "./landing-page";
export * from "./school-page";
export * from "./tutoring-page";
export * from "./privacy-policy-page";
